import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import RouteKey from '../../../routes/key';
import { useAuth } from '../logic/auth';

interface AnonymousOnlyRouteProps {
  /**
   * This children component will be rendered if user is not logged in.
   */
  children: React.ReactNode;
  /**
   * Specify whether the path needs to be matched exactly.
   * This prop will be passed to react-router-dom <Router> component's `exact` prop.
   */
  exact?: boolean;
  /**
   * The path that will be navigated to, if user is not logged in.
   * This prop will be passed to react-router-dom <Router> component's `path` prop.
   */
  path: string;
}

const { error } = RouteKey.child;
const { authorized } = RouteKey.error.child;

/**
 * This component is meant to be used as an enhanced react-router-dom <Route> component. It will automatically redirect
 * user to /auth/403 if the user is logged in. Whether the user is logged in or not, it depends on the useAuth() hook
 * `isUserLoggedIn` return.
 */
const AnonymousOnlyRoute = ({ children, exact, path }: AnonymousOnlyRouteProps) => {
  const authHook = useAuth();

  return (
    <Route
      exact={exact}
      path={path}
      render={({ location }) => {
        if (authHook.isUserLoggedIn) {
          return <Redirect to={{ pathname: `/${error}/${authorized}` }} />;
        }

        return children;
      }}
    />
  );
};

export default AnonymousOnlyRoute;
